import withStyles from '@material-ui/core/styles/withStyles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import SwipeableViews from 'react-swipeable-views';

import navPillsStyle from '../../assets/jss/material-dashboard-pro-react/components/navPillsStyle';
import { GridContainer, GridItem } from '../Grid';

class NavPills extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: props.active,
    };
  }

  handleChange = (event, active) => {
    this.setState({ active });
  };

  handleChangeIndex = (index) => {
    this.setState({ active: index });
  };

  render() {
    const {
      classes,
      tabs,
      direction,
      color,
      horizontal,
      disableTouch,
      alignCenter,
      'data-testid': dataTestId,
      id,
    } = this.props;
    const { active } = this.state;
    const flexContainerClasses = classNames({
      [classes.flexContainer]    : true,
      [classes.horizontalDisplay]: horizontal !== undefined,
    });
    const tabButtons = (
      <Tabs
        classes={{
          root         : classes.root,
          fixed        : classes.fixed,
          flexContainer: flexContainerClasses,
          indicator    : classes.displayNone,
        }}
        value={active}
        onChange={this.handleChange}
        centered={alignCenter}
      >
        {tabs.map((prop, idx) => {
          const icon = {};
          if (prop.tabIcon !== undefined) {
            icon.icon = <prop.tabIcon className={classes.tabIcon} />;
          }
          const pillsClasses = classNames({
            [classes.pills]          : true,
            [classes.horizontalPills]: horizontal !== undefined,
            [classes.pillsWithIcons] : prop.tabIcon !== undefined,
          });
          return (
            <Tab
              id={id ? `navpills.tab-${id}-${idx}` : undefined}
              data-testid={dataTestId ? `navpills.tab-${dataTestId}-${idx}` : undefined}
              label={prop.tabButton}
              key={prop.key}
              {...icon}
              classes={{
                root          : pillsClasses,
                labelContainer: classes.labelContainer,
                label         : classes.label,
                selected      : classes[color],
              }}
            />
          );
        })}
      </Tabs>
    );

    const tabContent = (
      <div className={classes.contentWrapper}>
        <SwipeableViews
          disabled={disableTouch}
          axis={direction === 'rtl' ? 'x-reverse' : 'x'}
          index={active}
          onChangeIndex={this.handleChangeIndex}
          style={{ overflowY: 'hidden' }}
        >
          {tabs.map(prop => (
            <div className={classes.tabContent} key={prop.key}>
              {prop.tabContent}
            </div>
          ))}
        </SwipeableViews>
      </div>
    );
    return horizontal !== undefined ? (
      <GridContainer>
        <GridItem {...horizontal.tabsGrid}>{tabButtons}</GridItem>
        <GridItem {...horizontal.contentGrid}>{tabContent}</GridItem>
      </GridContainer>
    ) : (
      <div>
        {tabButtons}
        {tabContent}
      </div>
    );
  }
}

NavPills.propTypes = {
  'data-testid': PropTypes.string,
  id           : PropTypes.string,
  classes      : PropTypes.object.isRequired,
  // index of the default active pill
  active       : PropTypes.number,
  tabs         : PropTypes.arrayOf(
    PropTypes.shape({
      tabButton : PropTypes.string,
      tabIcon   : PropTypes.func,
      tabContent: PropTypes.node,
    })
  ).isRequired,
  color     : PropTypes.oneOf(['primary', 'warning', 'danger', 'success', 'info', 'rose']),
  direction : PropTypes.string,
  horizontal: PropTypes.shape({
    tabsGrid   : PropTypes.object,
    contentGrid: PropTypes.object,
  }),
  disableTouch: PropTypes.bool,
  alignCenter : PropTypes.bool,
};

NavPills.defaultProps = {
  'data-testid': undefined,
  id           : undefined,
  active       : 0,
  color        : 'primary',
  horizontal   : undefined,
  alignCenter  : undefined,
  direction    : undefined,
  disableTouch : false,
};

export default withStyles(navPillsStyle)(NavPills);
